import configs from 'configs';

export default class WordPressUtil {

    /**
     * WordPressの単一記事情報を返すAPIのエンドポイント
     * @param {number} postId WordPress記事ID
     */
    wordPressPostUrl = (postId) => `${configs.wordPressPath}/wp-json/wp/v2/posts/${postId}`;
}